



























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'
import { totoalStation, highlightList } from '@/utils/config'
import logger from '@plat-components/utils2/_esm5/logger'
import { debounce } from 'throttle-debounce'

@Component({})
export default class timeLine extends Vue {
  @State('currPoint') currPoint
  @Mutation('setCurrPoint') setCurrPoint
  progressWidth = {}
  progressList = highlightList
  userTitle: any = []

  @Watch('currPoint')
  watchCurrPointChange(newVal) {
    if (newVal > totoalStation) {
      return false
    }
    this.refreshGiftIcon()
    let currStation = highlightList.findIndex(
      (item: any) => item.station >= newVal
    )
    const firstStation = highlightList[0]
    const lastStation = highlightList[highlightList.length - 1]
    // 判断是第几个大站点 再算百分比
    let isHead = currStation === 0
    let isTail = currStation === -1
    let unitWidth = 1 / 3.8
    let width = isHead
      ? (unitWidth * 0.4 * this.currPoint) / firstStation.station
      : isTail
      ? unitWidth * 3.4 +
        (unitWidth * 0.4 * (this.currPoint - lastStation.station)) /
          (totoalStation - lastStation.station)
      : unitWidth * (0.4 + currStation) +
        (unitWidth * (this.currPoint - highlightList[currStation].station)) /
          (highlightList[currStation].station -
            highlightList[currStation - 1].station)
    this.progressWidth = { width: `calc(${Math.round(width * 10000) / 100}%)` }
  }

  mounted() {
    this.refreshGiftIcon()
  }

  refreshGiftIcon() {
    const localStore = localStorage.getItem('getTitle')
    const titleInfo = (localStore && JSON.parse(localStore)) || []
    this.userTitle = highlightList.map((item: any) => {
      return titleInfo.some((titleItem) => titleItem === item.station)
    })
  }

  // 添加防抖
  debounceNavS = debounce(200, this.navToStation, { atBegin: true })

  navToStation(val: any) {
    const { station } = val
    logger('forecast_click', {
      periods: station,
    })
    this.$emit('onClickStation', station)
  }
}
